import styled from "styled-components";
import { Flex, Text } from "rebass";
import { DynamicNextLink } from "./dynamic-next-link";

const TagItem = ({ text, i, isLast }) => {
  return (
    <Tag
      className="underline"
      key={i}
      link={{
        internal: true,
        href: `/timeline-tags?tag=${text}`,
        as: `/timeline/tags/${text}`
      }}
      last={isLast}
    >
      {text}
    </Tag>
  );
};

const Tags = ({ tags }) => {
  return (
    <Text as={Flex} fontSize={1} fontFamily="medium">
      Tags:{" "}
      {tags.map((tag, i) => (
        <TagItem key={i} i={i} text={tag} isLast={i === tags.length - 1} />
      ))}
    </Text>
  );
};

const Tag = styled(DynamicNextLink)`
  display: inline-block;
  margin-left: 5px;

  &.underline a,
  a:hover {
    text-decoration: underline;
  }

  &:after {
    content: ${props => (props.last ? "''" : "','")};
  }
`;

export { Tags };
